module.exports = __webpack_public_path__ + "static/5-64df1f49d4adbd4757cc16c31575d19c.jpg";